import { gql } from '__generated__'

export const RemoveClientRole = gql(/* GraphQL */ `
    mutation RemoveClientRole($clientId: ID!, $companyId: ID!) {
        removeClientRole(clientId: $clientId, companyId: $companyId) {
            success
            message
        }
    }
`)

export const GrantClientRole = gql(/* GraphQL */ `
    mutation GrantClientRole(
        $companyId: ID!
        $email: String!
        $firstName: String
        $lastName: String
    ) {
        grantClientRole(
            companyId: $companyId
            email: $email
            firstName: $firstName
            lastName: $lastName
        ) {
            success
            message
        }
    }
`)

export const MakeClientCompanyAdmin = gql(/* GraphQL */ `
    mutation MakeClientCompanyAdmin($clientId: ID!, $companyId: ID!) {
        makeAdmin(clientId: $clientId, companyId: $companyId) {
            success
            message
        }
    }
`)

export const CanGrantClientRole = gql(/* GraphQL */ `
    query CanGrantClientRole($email: String!, $companyId: ID!) {
        canGrantClientRole(email: $email, companyId: $companyId) {
            result
            message
        }
    }
`)
